<template>
    <div id="wrapper" style="min-width: 98vw; box-sizing: border-box">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.report.terms-accepted.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="form.systemUser">
                        <div class="col-md-12">
                            <div class="card-box">
                                <form @submit="saveStatus()">
                                    <div class="form-row">
                                        <div class="form-group col-md-6 col-12">
                                            <label class="col-form-label">Usuário/empresa</label>
                                            <input type="text" v-model="form.fullname" class="form-control" readonly="true" />
                                        </div>
                                        <div class="form-group col-md-6 col-12">
                                            <label class="col-form-label">
                                                {{$t('string.msg.register.status.label')}}
                                            </label>
                                            <select id="status" v-model="form.status" class="form-control">
                                                <option :value="null">{{$t('string.msg.select.selector.all.status')}}</option>
                                                <option value="ACTIVE">{{$t('string.msg.select.selector.active')}}</option>                                        
                                                <option value="ARCHIVED">{{$t('string.msg.select.selector.archived')}}</option>
                                            </select>                                    
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button class="btn btn-success w-20" type="submit">Salvar</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        
                    </div>

                    <div class="row">

                        <div class="col-md-12">
                            <div class="card-box">
                                <form action="">

                                    <div class="form-row">

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                Tipo de usuário
                                            </label>
                                            <select id="truck" v-model="filters.userType" class="form-control" @change="changeUserType()">
                                                <option value="USER-COMPANY" selected>Associados</option>
                                                <option value="USER-CUSTOMER">Caminhoneiros</option>                                                
                                            </select>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                Status do usuário
                                            </label>
                                            <select id="truck" v-model="filters.status" class="form-control">
                                                <option :value="null" selected>Todos</option>
                                                <option value="ACTIVE">Ativado</option>
                                                <option value="ARCHIVED">Arquivado</option>
                                            </select>
                                        </div>

                                    </div>

                                    <div class="form-row">

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                Nome do usuário
                                            </label>
                                            <autocomplete
                                                :search="onChangeName"
                                                :get-result-value="getResultValue"
                                                @submit="submitFilter"
                                                debounceTime="500"
                                            ></autocomplete>              
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                Termo aceito
                                            </label>
                                            <select id="truck" v-model="filters.termAccepted" class="form-control">
                                                <option value="none" selected>Selecione uma opção</option>
                                                <option value="any">Pelo menos um aceite</option>
                                                <option value="all">Aceitou todos os termos</option>
                                                <option value="purchase">Apenas aceite de compra</option>
                                                <option value="general">Apenas aceite geral</option>
                                            </select>
                                        </div>

                                    </div>

                                    <div class="form-row">

                                        <div class="col-md-4">
                                            <div class="d-flex justify-content-center">
                                                <button @click="filter" class="btn btn-success w-30" style="width: 200px">
                                                    {{$t('string.msg.form.btn.search')}}
                                                </button>
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <div class="d-flex justify-content-center">
                                                <div>
                                                    <h4 class="text-center">Total</h4>
                                                    <h4 class="text-center" style="color:grey">{{ total }}</h4>
                                                </div>                                                
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <div class="d-flex justify-content-center">
                                                <download-excel
                                                    v-if="items.length > 0"
                                                    class="btn btn-primary"
                                                    :fetch="fetchData"
                                                    :fields="csv_export.fields"
                                                    :meta="csv_export.meta"
                                                    type="csv"
                                                    name="Relatório do termos.xls"
                                                >Download CSV</download-excel>
                                            </div>
                                        </div>

                                    </div>

                                </form>
                                
                            </div>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-md-12">
                            <div class="card-box">

                                <div class="table-responsive">
                                    <table class="table table-centered table-hover mb-0" id="datatable">
                                        <thead>
                                            <tr>
                                                <th class="border-top-0" style="width:20%">{{$t('string.msg.trucker.table.header.name')}}</th>
                                                <th class="border-top-0" style="width:20%">{{$t('string.msg.trucker.table.header.primaryPhone')}}</th>
                                                <th class="border-top-0" style="width:20%">{{$t('string.msg.trucker.table.header.email')}}</th>
                                                <th class="border-top-0" style="width:20%">Status</th>
                                                <th class="border-top-0" style="width:20%">Termos de compra</th>
                                                <th class="border-top-0" style="width:20%">Termos de uso</th>
                                            </tr>
                                        </thead>
                                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                                            <tr v-if="item.type === 'USER-CUSTOMER' || (item.type === 'USER-COMPANY' && item.company)"
                                                @click="selectItem(item)">
                                                <td>{{ camelize(item.firstName + ' ' + item.lastName) }}</td>
                                                <td>{{ item.type === 'USER-CUSTOMER' ? item.primaryPhone : item.company.primaryPhone }}</td>
                                                <td>{{ item.email }}</td>
                                                <td v-if="item.company">                                                    
                                                    {{ item.company.status }}                                                    
                                                </td>
                                                <td v-else>
                                                    {{ item.status }}
                                                </td>
                                                <td>{{ item.isAcceptPurchaseTerms === true ? 'Sim' : 'Não' }}</td>
                                                <td>{{ item.isAcceptGeneralTerms === true ? 'Sim' : 'Não' }}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>

                                <!--<nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item" v-for="index in total" v-bind:key="index" 
                                        style="cursor: pointer">
                                        <a class="page-link" @click="setPage(index)">{{ index }}</a>
                                        </li>
                                    </ul>
                                </nav>-->

                            </div>
                        </div>

                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Controller from './CtrListTermAccepted'
import Spinner from '../../../components/layout/Spinner';
//import Vue from 'vue'
export default {
    name: 'ListTermAccepted',
    components: { 
        Spinner
    },
    data() {
        return {
            items: [],
            truckerName: '',
            form: {
                /*fullname: null,
                systemUser: null,
                status: null*/
            },
            csv_export: {
                fields: {
                    Nome: 'firstName',
                    Sobrenome: 'lastName',
                    Telefone: 'primaryPhone',
                    Email: 'email',
                    'Aceitou uso': 'isAcceptGeneralTerms',
                    'Aceitou compra': 'isAcceptPurchaseTerms'
                },
                json_data: [
                    {                        
                        firstName: null,
                        lastName: null,
                        primaryPhone: null,
                        email: null,
                        isAcceptGeneralTerms: null,
                        isAcceptPurchaseTerms: null
                    },
                ],
                meta: [
                    [
                        {
                            key: "charset",
                            value: "utf-8",
                        }
                    ],
                ],
            },
            filters: {
                userType: 'USER-COMPANY',
                pageIndex: 0,
                limit: 20,
                termAccepted: 'none',
                systemUser: null,
                status: null
            }
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this);
    },
    mounted() {
    }    
}
</script>
